import api from '../../services/apiService'

const userSession = "/biz/users?action=current-session";
const userRoles = "/biz/userroles";

const getSession = () => api.framework.get(userSession);
const getRoles = (filter) => api.framework.get(`${userRoles}?${filter}`);

const getUserSession = () => getSession().then(res => res.data);

const getUser = () => {
  return getUserSession().then(res => {
    return getRoles(`filter=UserID eq ${res.ID}&expand=SharedRole`).then(userRoles => {
      const { Permissions, ...userWithoutPermissions } = res
      const isAdmin = userRoles.data && userRoles.data.some(role => {
        return (role.SharedRoleName === 'Administrator');
      });
      return { ...userWithoutPermissions, IsAdministrator: isAdmin }
    });
  })
}
export { getUser };